import { HTTPMethod } from 'helpers/method';
import { ENDPOINT } from 'services/configs/endpoint.constant';

import {
  DeleteFilesPayload,
  GetListFilesParams,
  GetListFilesResponse,
  GetReadTokenResponse,
  GetTermsOfServiceResponse,
} from './document.type';
import { request } from '../configs/axiosConfig';

export const DocumentService = {
  getReadToken: async () => {
    return request<GetReadTokenResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_READ_TOKEN,
    });
  },
  getListFiles: async (params: GetListFilesParams) => {
    return request<GetListFilesResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_FILES,
      params,
    });
  },
  deleteFiles: async (data: DeleteFilesPayload) => {
    return request({
      method: HTTPMethod.DELETE,
      url: ENDPOINT.DELETE_FILES,
      data,
    });
  },
  getTermsOfServiceStatus: async () => {
    return request<GetTermsOfServiceResponse>({
      method: HTTPMethod.GET,
      url: ENDPOINT.GET_TERMS_OF_SERVICE_STATUS,
    });
  },
  updateTermsOfServiceStatus: async () => {
    return request({ method: HTTPMethod.POST, url: ENDPOINT.UPDATE_TERMS_OF_SERVICE_STATUS });
  },
};
